import { useState, useEffect, useRef } from "react";
import View from "@components/View";
import "./LoadingBar.css";

interface LoadingBarProps {
  text: string;
  percentage: number;
  color: string;
  textClassName?: string;
  loadingBarClassName?: string;
}

const lerp = (start: number, end: number, amount: number) => {
  return (1 - amount) * start + amount * end;
};

export const LoadingBar = ({
  text,
  percentage,
  color,
  textClassName,
  loadingBarClassName,
}: LoadingBarProps) => {
  const [displayPercentage, setDisplayPercentage] = useState(0);
  const requestRef = useRef<number | null>(null);

  const updatePercentage = () => {
    setDisplayPercentage((prev) => lerp(prev, percentage, 0.1));
    if (Math.abs(displayPercentage - percentage) < 0.01) {
      cancelAnimationFrame(requestRef.current!);
    } else {
      requestRef.current = requestAnimationFrame(updatePercentage);
    }
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(updatePercentage);
    return () => cancelAnimationFrame(requestRef.current!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentage]);

  return (
    <>
      <View
        className={`text-lg text-black font-[Slackey] ${textClassName}`}
        style={{ color }}
      >
        {text}
      </View>
      <View className="loading-bar">
        <svg className="loading-bar-svg">
            <rect className="loading-bar-bg" style={{ stroke: color }} x="2%" y="20%" width="96%" height="60%" rx="5" ry="5" />
            <rect
                className="loading-bar-fg"
                style={{ fill: color }}
                x="2%" y="20%" height="60%" rx="5" ry="5"
                width={`${displayPercentage * 0.96}%`}
                fill="#FF0000" 
            />
        </svg>
      </View>
    </>
  );
};
